import styled from 'styled-components';
import { playGrey15 } from '../../ui-components/design-tokens';
import { device } from '../../ui-components/breakpoints';
import { ClearFix } from '../../ui-components/utils.styles';
import {
    PlayListHeading,
    PlayListHeaderPadding,
} from '../../ui-components/typography/PlayListHeading.styles';

export const StyledPlaceHolderContainer = styled.section`
    position: relative;
    clear: both;

    margin-top: 20px;
    border-bottom: 1px solid ${playGrey15};

    @media ${device.GteSmall} {
        margin-top: 35px;
    }
`;

export const StyledPlaceHolderHeaderWrapper = styled.div`
    ${ClearFix}
    position: relative;
    z-index: 3;
`;

export const StyledPlaceHolderHeader = styled(PlayListHeading)`
    ${PlayListHeaderPadding}
`;
